export default __webpack_public_path__ + "media/images/react_icons/whatsapp_light-17283d489fd6503623093855f58af01d.svg";